new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#app_home',
    data: {
        activeIndex: 1,
    },
    methods: {
        toggleShowcase(index) {
            this.activeIndex = index;
        }
    },
    mounted() {
        waitForElementToExist('#faixa-cupom').then(element => {
            const faixCupom = document.querySelector('.faixa-cupom');

            if (faixCupom) {
                const formButton = document.querySelector('.faixa-cupom-form button');
                const spanElement = document.getElementById("valorParaCopiar");

                if (spanElement && formButton) {
                    let newValue = spanElement.textContent.replace(/^\/\//, '');

                    const icon = formButton.querySelector('i');
                    const originalText = formButton.textContent;

                    formButton.addEventListener("click", (e) => {
                        e.preventDefault();

                        navigator.clipboard.writeText(newValue).then(() => {

                            // altera texto mantendo o ícone
                            if (icon) {
                                formButton.innerHTML = 'Copiado!';
                            } else {
                                formButton.textContent = 'Copiado!';
                            }

                            // volta ao original após 2s
                            setTimeout(() => {
                                if (icon) {
                                    formButton.innerHTML = icon.outerHTML + ' ' + originalText.trim();
                                } else {
                                    formButton.textContent = originalText;
                                }
                            }, 2000);

                        }).catch(err => {
                            console.error('Erro ao copiar: ', err);
                        });
                    });
                }
            }
        });
    },
});

//sliders
$(document).ready(function () {

    var bannerHomeFull = $('.banner-home');
    var optionsBannerHome = {
        swipeToSlide: true, 
        touchThreshold: 100,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 4000,
        dots: false,
        infinite: true,
        mobileFirst: true,
        adaptiveHeight: true,
        pauseOnHover: true,
        pauseOnFocus: true,
        slidesToShow: 1,
        speed: 2000,
        cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',
    }

    // Init banner
    function initBannerHome(el) {
        el.slick(optionsBannerHome);
    }

    bannerHomeFull.on('init', function (event, slick) {
        $('.banner-home').find('.banner-home__loading').hide();
        $('.slider-slick').css({
            visibility: 'visible',
            opacity: '1'
        });
    });

    initBannerHome(bannerHomeFull);

    
     waitForElementToExist('#js-categories-list').then(element => {
        $('#js-categories-list').slick({
            swipeToSlide: true, 
            touchThreshold: 100,
            arrows: false,
            dots: false,
            infinite: true,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 1000,
            responsive: [
                {
                    breakpoint: 991,
                    settings: 'unslick'
                }
            ]
        });
    });

     waitForElementToExist('.first-vitrine').then(element => {
        const firstCarrousel = element.querySelector('#product_list');
        if (firstCarrousel) {
            $('#product_list').slick({
                arrows: false,
                swipeToSlide: true, 
                touchThreshold: 100,
                dots: false,
                infinite: true,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 1000,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            arrows: true,
                            slidesToScroll: 4,
                            slidesToShow: 4,
                        }
                    },
                ]
            });

            $('#product_list').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function (element) {
                        setTimeout(function () {
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.second-vitrine').then(element => {
        const firstCarrousel = element.querySelector('#product_list2');
        if (firstCarrousel) {
            $('#product_list2').slick({
                arrows: false,
                swipeToSlide: true, 
                touchThreshold: 100,
                dots: false,
                infinite: true,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 1000,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            arrows: true,
                            slidesToScroll: 4,
                            slidesToShow: 4,
                        }
                    },
                ]
            });

            $('#product_list2').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function (element) {
                        setTimeout(function () {
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.banner-product').then(element => {
        $('#product-banner').slick({
            swipeToSlide: true, 
            touchThreshold: 100,
            arrows: true,
            dots: true,
            infinite: true,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 1000,
        });

        $('#product-banner').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            Blazy({
                selector: '.lazy-img',
                successClass: 'loaded-img',
                success: function (element) {
                    setTimeout(function () {
                        var parent = element.previousSibling;
                        try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                    }, 200);
                }
            });
        });
    });

    waitForElementToExist('#banner-product-2').then(element => {
        $('#product-banner2').slick({
            swipeToSlide: true,
            touchThreshold: 100,
            arrows: true,
            dots: true,
            infinite: true,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 1000,
        });

        $('#product-banner2').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            Blazy({
                selector: '.lazy-img',
                successClass: 'loaded-img',
                success: function (element) {
                    setTimeout(function () {
                        var parent = element.previousSibling;
                        try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                    }, 200);
                }
            });
        });
    });

    waitForElementToExist('.banner-como-usam').then(element => {
        $('.banner-como-usam-slider').slick({
            swipeToSlide: true,
            touchThreshold: 100,
            arrows: false,
            dots: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 3000,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 1000,
            responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToScroll: 1,
                            slidesToShow: 6,
                        }
                    },
                ]
        });
    });

});